import React, { useEffect, useState } from 'react';
import styles from './PaymentConfirmation.module.css';
import success from "../../../Assets/Images/success.webp"
import fail from "../../../Assets/Images/fail.png"
import { useNavigate, useLocation } from 'react-router-dom';


const PaymentConfirmation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSuccess,setisSuccess]=useState(true)

  const { status = 'success' } = location.state || {}; 

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);



  return (
    <div className={styles.container}>
      <div className={styles.card}>
        {isSuccess ? (
          <img src={success} alt='success' height={100} width={100}/>
        ) : (
          <img src={fail} alt='fail' height={100} width={100}/>
        )}
        <h2>{isSuccess ? 'Payment Successful' : 'Payment Failed'}</h2>
        <p className={styles.message}>
          {isSuccess
            ? 'Thank you! Your payment has been processed successfully. Your wallet balance will be updated shortly.'
            : 'Unfortunately, your payment could not be processed. Please try again later or contact support.'}
        </p>
        <p className={styles.redirect}>Redirecting to the home page...</p>
      </div>
    </div>
  );
};

export default PaymentConfirmation;
